import { render, staticRenderFns } from "./home3.vue?vue&type=template&id=a3a2eeee&"
import script from "./home3.vue?vue&type=script&lang=js&"
export * from "./home3.vue?vue&type=script&lang=js&"
import style0 from "./home3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VIcon,VMain,VScaleTransition})
